export default __webpack_public_path__ + "static/enable-0ffb7a4d92bccbbda066edbb3eb45c61.svg";